// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"c5a73e9a","355":"8d70ffe5","453":"72ef8245","644":"29e4954d","708":"107791ed","904":"a01023d4","908":"d6738430"}[chunkId] + ".chunk.js";
};